
import { useState } from "react";

export const usePaymentFormState = () => {
  const [isSendingEmail, setIsSendingEmail] = useState(false);
  const [isSendingSms, setIsSendingSms] = useState(false);
  const [watchIncludeReviewLink, setWatchIncludeReviewLink] = useState(false);
  const [watchIncludeAddress, setWatchIncludeAddress] = useState(false);
  const [watchIncludePdfReceipt, setWatchIncludePdfReceipt] = useState(false);
  const [selectedReviewPlatform, setSelectedReviewPlatform] = useState("");

  return {
    isSendingEmail,
    setIsSendingEmail,
    isSendingSms,
    setIsSendingSms,
    watchIncludeReviewLink,
    setWatchIncludeReviewLink,
    watchIncludeAddress,
    setWatchIncludeAddress,
    watchIncludePdfReceipt,
    setWatchIncludePdfReceipt,
    selectedReviewPlatform,
    setSelectedReviewPlatform
  };
};
